/*
 * everhound — guarda do plano no carrinho (T38, 30/10/2026).
 *
 * Na -special cada quantidade de potes tem o proprio plano (1 a 6). Com o brinde no carrinho, a
 * Shopify divide a linha dos potes acima de 3: 3 com o desconto Buy X Get Y e o resto noutra
 * linha, com key propria. O plano tem de seguir o TOTAL de potes do mesmo produto e porte (a
 * "familia", data-eh-fam no snippets/cart-products.liquid). O "+" e o "-" ja mandam o plano do
 * total (component-cart-items.js); esta guarda cobre os outros caminhos: remover uma das linhas
 * divididas, ou somar potes pelo buy box (3 + 3 ficavam 6 potes no plano de 3, a cada 180 dias).
 *
 * A cada cart:update (e no load): soma os potes de cada familia; se alguma linha nao esta no plano
 * do total (data-eh-plan-cur), muda o plano pela propria linha, pelo fluxo do tema
 * (cart-items-component.updateQuantity, com a mesma quantidade e o selling_plan), e a Shopify leva
 * as linhas divididas junto. Uma correcao por vez; o proximo cart:update confere de novo. Com o
 * brinde a sair (familia abaixo de 3 com a coleira ainda la), espera a guarda do brinde.
 * Acima de 6 nao ha plano: nada muda (o "+" ja para em 6).
 *
 * T63k (01/11, achado do T63g, aprovado pelo Matheus): a linha que muda e a que esta FORA do plano
 * do total, nao a 1a da familia. Potes somados com planos diferentes ficam em linhas separadas, e a
 * Shopify poe a nova em cima: 2 potes (plano de 2) + 1 pelo buy box (plano de 1) mudava so a de 1
 * pote para o plano de 3; a de 2 ficava no plano de 2 e o checkout teria duas assinaturas (1 pote a
 * cada 180 dias e 2 a cada 120). Nem o /cart acertava: no load ele tornava a mandar a 1a linha, ja
 * certa, para o mesmo plano. O mesmo com 1 + 1 + 1 e 1 + 2. Com mais de uma linha fora, vai uma por
 * cart:update, cada uma com a sua marca no "feitas" (a linha entra nela pela key).
 */
(function () {
  'use strict';
  if (window.__ehCartPlanGuard) return;
  window.__ehCartPlanGuard = true;

  /* a mesma correcao (familia, total, plano) nao se repete em menos de 8 s: se a Shopify recusar,
     nao entra em laco */
  var feitas = {};

  function check() {
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.__ehRemovingGift || c.__ehFixingPlan || typeof c.updateQuantity !== 'function') return;
      var rows = c.querySelectorAll('tr[data-eh-fam]');
      if (!rows.length) return;
      var temBrinde = !!c.querySelector('tr[data-eh-gift="true"]');
      var fams = {};
      rows.forEach(function (r) { var f = r.getAttribute('data-eh-fam'); (fams[f] = fams[f] || []).push(r); });

      Object.keys(fams).some(function (f) {
        var rs = fams[f];
        var total = 0;
        rs.forEach(function (r) { total += parseInt(r.getAttribute('data-eh-qty'), 10) || 0; });
        if (temBrinde && total < 3) return false;
        var plans;
        try { plans = JSON.parse(rs[0].getAttribute('data-eh-plans') || '{}'); } catch (e) { return false; }
        var alvo = plans[String(total)];
        if (!alvo) return false;
        /* T63k: a 1a linha fora do plano, nao rs[0] (que pode ja estar nele). Nas linhas divididas
           pela coleira (T38/T58) as duas tem o mesmo plano: a 1a fora e rs[0], como antes */
        var r0 = null;
        rs.some(function (r) { if (r.getAttribute('data-eh-plan-cur') !== String(alvo)) { r0 = r; return true; } return false; });
        if (!r0) return false;
        /* a key da linha entra na marca: depois de acertar uma linha, a outra fora do plano nao fica
           presa nos 8 s da primeira; a mesma linha recusada segue sem repetir */
        var sig = f + ':' + total + ':' + alvo + ':' + r0.getAttribute('data-key');
        if (feitas[sig] && Date.now() - feitas[sig] < 8000) return false;
        feitas[sig] = Date.now();

        var line = parseInt(r0.getAttribute('data-eh-line'), 10);
        var q = parseInt(r0.getAttribute('data-eh-qty'), 10);
        if (!(line > 0) || !(q > 0)) return false;
        c.__ehFixingPlan = true;
        window.setTimeout(function () { c.__ehFixingPlan = false; }, 1500);
        c.updateQuantity({ line: line, quantity: q, action: 'change', sellingPlan: String(alvo) });
        return true;
      });
    });
  }

  /* depois da guarda do brinde (60 ms), para ela tirar a coleira primeiro quando for o caso.
     T58: e de novo a 800 e a 1700 ms. Num add pelo buy box o cart:update sai antes de a gaveta
     ser redesenhada, e a 150 ms ela ainda mostrava o carrinho de antes: 3 + 3 ficava no plano de
     3 ate o cliente abrir o /cart (que confere no load). A conferencia e idempotente, e o
     "feitas" e o __ehFixingPlan seguram a repeticao. */
  document.addEventListener('cart:update', function () {
    [150, 800, 1700].forEach(function (ms) { window.setTimeout(check, ms); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
